import { Entity } from '../../../types';
import { HorizontalAlignment, HorizontalAlignmentResource } from '../../Alignment/Alignment';
import {
    DefaultComponent,
    DefaultComponentAppearance,
    DefaultComponentAppearanceResource,
    DefaultComponentResource,
} from '../../Component/Component';
import { Link, LinkResource } from '../../Link/Link';
import {
    Image,
    MediaEntityResource,
    ResponsiveImage,
    ResponsiveImageResource,
} from '../../Media/Media';

export enum VisualCarouselLayoutResource {
    fullWidth = 'Full width',
    halfWidth = 'Half width',
}

export interface VisualCarouselSlideResource {
    id: string;
    title: string;
    intro?: string;
    paragraph?: string;
    label?: string;
    align: HorizontalAlignmentResource;
    links?: LinkResource[];
    image?: Entity<MediaEntityResource>;
    images?: ResponsiveImageResource[];
}

export interface VisualCarouselResource extends DefaultComponentResource, DefaultComponentAppearanceResource {
    id: string;
    title?: string;
    layout?: VisualCarouselLayoutResource;
    slides: VisualCarouselSlideResource[];
}

export enum VisualCarouselLayout {
    fullWidth = 'fullWidth',
    halfWidth = 'halfWidth',
}

export interface VisualCarouselSlideInterface {
    id: string;
    align: HorizontalAlignment;
    title: string;
    intro: string;
    paragraphHtml: string;
    links: Link[];
    image?: Image;
    responsiveImages: ResponsiveImage[];
}

export interface VisualCarouselInterface extends DefaultComponent, DefaultComponentAppearance {
    layout: VisualCarouselLayout;
    title: string;
    slides: VisualCarouselSlideInterface[];
}
